import type { Product } from "@bioflow/contracts";
import { PRODUCT_SHOT } from "../content/site";

/**
 * Product shot — рендер флакона от заказчика. Берётся из карточки товара,
 * а если фото в БД нет — резервный файл из /public. Размер задаёт класс:
 * hero на стартовом экране и главной, small — в чекауте и на экране заказа,
 * wide — во всю ширину на финальном экране онбординга.
 */
export function ProductShot({
  product,
  size = "hero",
}: {
  product?: Pick<Product, "images" | "title">;
  size?: "hero" | "small" | "wide";
}) {
  const image = product?.images[0];
  return (
    <div className={`shot shot--${size}`}>
      <img src={image?.src ?? PRODUCT_SHOT} alt={image?.alt ?? product?.title ?? "Tirzepatide"} />
    </div>
  );
}
